/* eslint-disable require-jsdoc */
import React from 'react';
import loader from './loader.gif';

export default function Loader() {
  return (
    <div className="loader-container">
      <div className="loader-parent">
        <img src={loader} className="loader" />
      </div>
    </div>
  );
}
